
import { AxiosHelper } from '../helpers/AxiosHelper';


const Get = async (formData: FormData) => {
    return AxiosHelper.post('/Environment/Get', formData);
}


const EnvironmentService = {
    Get
}

export default EnvironmentService;